import { Switch } from "@mui/material";
import "./ToggleSwitch.css";
import PropTypes from "prop-types";

const ToggleSwitch = (props) => {
  const { activeLabelText, inactiveLabelText, state, onChange, disabled, id } =
    props;
  /* Optional, opt-in label colors. When provided, override the default
   * label color. `disabledLabelColor` wins when the toggle is disabled. */
  const { activeLabelColor, inactiveLabelColor, disabledLabelColor } = props;
  let labelColor;
  if (disabled && disabledLabelColor) labelColor = disabledLabelColor;
  else if (state && activeLabelColor) labelColor = activeLabelColor;
  else if (!state && inactiveLabelColor) labelColor = inactiveLabelColor;
  return (
    <div className="toggle-switch-root">
      <Switch
        checkedIcon={
          disabled ? (
            <img src="/images/active_greyed.png" height={28} alt="active" />
          ) : (
            <img src="/images/active.png" height={28} alt="active" />
          )
        }
        icon={
          disabled ? (
            <img src="/images/inactive_greyed.png" height={28} alt="active" />
          ) : (
            <img src="/images/inactive.png" height={28} alt="inactive" />
          )
        }
        checked={state}
        onChange={onChange}
        disabled={disabled || props.coloredDisable}
        name={id}
        id={id}
        data-testid={props.dataTestId ? props.dataTestId : "activeCheckbox"}
      />
      <div
        className="status-label"
        style={labelColor ? { color: labelColor, fontWeight: 600 } : undefined}
      >
        {state ? activeLabelText : inactiveLabelText}
      </div>
    </div>
  );
};

ToggleSwitch.propTypes = {
  activeLabelText: PropTypes.string,
  inactiveLabelText: PropTypes.string,
  state: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  coloredDisable: PropTypes.bool,
  dataTestId: PropTypes.string,
  activeLabelColor: PropTypes.string,
  inactiveLabelColor: PropTypes.string,
  disabledLabelColor: PropTypes.string,
};

ToggleSwitch.defaultProps = {
  activeLabelText: "Active",
  inactiveLabelText: "Inactive",
  state: false,
  onChange: () => { },
  disabled: false,
  id: "",
  coloredDisable: false,
  dataTestId: "",
  activeLabelColor: "",
  inactiveLabelColor: "",
  disabledLabelColor: "",
};

export default ToggleSwitch;
